import ServiceQueue from '../types/ServiceQueue';
import { serviceState } from './state';

function getQueue(queueId: string): ServiceQueue | null {
  return serviceState.queueById[queueId] || null;
}

export default getQueue;
